<div class="card shadow-sm rounded-0 border-0">
     <div class="card-body">
          <h2 id="supportHeaderDiv" class="card-title h5 mt-0">
               <span [innerHtml]="'HaveQuestions' | translator: 'base'">Have Questions?</span>
          </h2>
          <p>
               <span [innerHtml]="'Welcome_HaveQuestions1' | translator:'base'">
                    The PSP customer service team is available
                    Monday through Thursday from 8 AM to 6 PM ET,
                    and on Friday from 8 AM to 5 PM ET. To chat with
                    an online representative, click the "LIVE HELP"
                    button in the top-right corner of this page. You
                    can also email us at </span>
               <a href="mailto:PSPenrollment@tylertech.com" title="PSPenrollment@tylertech.com"
                    name="PSPenrollment@tylertech.com">PSPenrollment&#64;tylertech.com</a>

               <span [innerHtml]="'Welcome_HaveQuestions2' | translator:'base'"> or call toll-free at </span>
               <a name="1-877-642-9499" href="tel:8776429499" title="Phone number 8776429499">1-877-642-9499</a>.
          </p>
          <button [routerLink]="'/customerSupport'" class="btn btn-outline-primary btn-sm"
               [title]="'Contact' | translator: 'base'" name="customerSupportLink" id="customerSupportLink"
               tabindex="0">
               <span [innerHtml]="'Contact' | translator: 'base'">Contact</span>
          </button>
     </div>
</div>